import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-bid-request-rate-breakup-modal',
  templateUrl: './bid-request-rate-breakup-modal.component.html',
  styleUrls: ['./bid-request-rate-breakup-modal.component.scss']
})
export class BidRequestRateBreakupModalComponent implements OnInit {

tableDetails: ITableModel;
  @Input() OrderId:any;
  @Input() NetworkId:any;
  @Input() VehicleTypeId:any;
  @Input() isBidding:boolean;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  @Output() onRefreshParent = new EventEmitter<any>();
  UserId:any;
  selectedRate=0;
  selectedAmount=0;
  @Input() totalBidAmount=0;
  @Input() TransportersBidsId:any;
  @Input() TransportersBidsDetailsId:any;
  @Input() AvailableDate:any;
  @Input() selectedFilter: string = 'Active';
  @Input() IsContracted: any;
  
  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
  ) { }

  ngOnInit() {
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.Inizialize();
    this.checkShipNowChargeBreakupData();
  }

  Inizialize(){
     this.tableDetails = {
      emptyDataMSg: "No Records Found",
      data: [],
      columnDetails: [
        { columnName: 'Sr.No', dataFieldName: 'SerialNumber',},
        { columnName: 'Charge', dataFieldName: 'Charge',},
        { columnName: 'Unit', dataFieldName: 'Unit',},
        { columnName: 'Qty', dataFieldName: 'Qty', alignType:'right',divType:'toshowvaluewithDecimals'},
        { columnName: 'Rate', dataFieldName: 'Rate', alignType:'right',divType:'toshowvaluewithDecimals'},
        { columnName: 'Amount', dataFieldName: 'Amount',alignType:'right',divType:'toshowvaluewithDecimals'},
      ],
      footerData: [
        { SerialNumber: 'Total', Charge: '', Unit: '', Qty: '', Rate: '', Amount: 0.00 },
      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: true
    };
  }

  GetExpenseBifurcation() {
     const Payload={
      OrderId:this.OrderId,
      OwnerId:this.NetworkId,
      BookingId:null,
      NewVehicleTypeId:this.VehicleTypeId
    };
    Helpers.setLoading(true)
    this._appService.Post('OrdersByVehicle', 'GetExpenseBifurcationForContracted', Payload).subscribe(
      (response) => {
        if(response.length){
          this.tableDetails.data = response || [];
          this.tableDetails.data = response.map((item, index) => {
            return {
              ...item,
              SerialNumber: index + 1
            };
          });
        }
        this.CalFooterValue();
        Helpers.setLoading(false)
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        Helpers.setLoading(false)
      }
    );
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  checkShipNowChargeBreakupData() {
  const Payload = {
    IndentId:this.OrderId,
    TransporterId:this.NetworkId,
    isBidding: this.isBidding,
    VehicleTypeId:this.VehicleTypeId
  };
  this._appService
    .Post(
      'OrdersByVehicle',
      'CheackShipNowChargeBreakupData',
      Payload
    )
    .subscribe(
      (response) => {
        if ( 
          response &&
          response.length > 0 &&
          response[0] &&
          response[0].Result === 'No'
        ) {
          this.GetExpenseBifurcation();
        }else{
          this.GetShipNowChargeBreakupList();
        }
      },
      (error) => {
        console.error('Error while checking charge breakup data');
      }
    );
  }

  GetShipNowChargeBreakupList() {
    Helpers.setLoading(true)
    const Payload = {
      IndentId:this.OrderId,
      TransporterId:this.NetworkId,
      isBidding: this.isBidding,
      VehicleTypeId:this.VehicleTypeId
    };
    this._appService.Post('OrdersByVehicle', 'GetShipNowChargeBreakupListByVehicle', Payload).subscribe(
      (response) => {
        if(response.length){
          this.tableDetails.data = response || [];
          
          if(this.selectedFilter === 'Active'){
            this.tableDetails.columnDetails.push({
              columnName: "Actions",
              dataFieldName: '',
              dataFieldName2: 'IsEditRow',
              divType: 'UpdateAction',
              alignType: 'right',
              width: '10%'
            });
          }

          this.tableDetails.data = response.map((item, index) => {
            return {
              ...item,
              SerialNumber: index + 1
            };
          });
        }
        this.CalFooterValue();
        Helpers.setLoading(false)
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        Helpers.setLoading(false)
      }
    );
  }

  onActionClick({ row, actionName, index }){
    console.log('row',row);
    console.log('actionName',actionName);
    console.log('index',index);
    if (actionName.trim() == "EditRow") {
      row.IsEditRow = true;
      row.bidRequestDropDown = true;
      const rateColumn = this.tableDetails.columnDetails.find(
        col => col.columnName === "Rate"
      );
      const unitColumn = this.tableDetails.columnDetails.find(
        col => col.columnName === "Unit"
      );

      if (rateColumn) {
        rateColumn.rowEditInput = true;
        rateColumn.inputField = {
          placeholder: 'Enter Rate',
          formControlName: 'rate',
          dataField: 'rate',
          type: "number",
          alignType: 'right',
          isReadOnly: false
        }
      }

      if (unitColumn) {
        unitColumn.rowEditbidRequestDropdown = true;
        unitColumn.bidRequestDropdownField = {
          lable: "",
          formControlName: "Unit",
          dataField: "Unit",
          isRequired: false,
          placeholder: "Select Unit",
          isValueBind: true,
          isSearchByApi: true,
          isSearch: false,
          dropdownList: row.Unit
            ? [{
              value: row.Unit,
              name: row.Unit
            }]
            : []
        }
      }
    } else if (actionName.trim() == "CloseRow") {
      row.IsEditRow = false;
      row.bidRequestDropDown = false;
      // const unitColumn = this.tableDetails.columnDetails.find(
      //   col => col.columnName === "Unit"
      // );
      // if (unitColumn) {
      //   unitColumn.rowEditbidRequestDropdown = false;
      // }
    } else if (actionName.trim() == "Update") {
      this.UpdateMRPRate(row);
      row.IsEditRow = false;
      row.bidRequestDropDown = false;
    }
  }

  UpdateMRPRate(row: any){
    console.log('row',row);
    console.log('selectedRate',this.selectedRate);
    if(this.selectedRate === 0){
      this.selectedRate = row.Rate;
      this.selectedAmount = row.Amount;
    }else{
      this.selectedAmount = row.Qty * this.selectedRate;
    }
    let Id=row.Id
    
    let VehicleTypeId = row && row.VehicleTypeId || null;

    this._appService.GetBySevenId('OrdersByVehicle','UpdateShipNowChargeBreakupRate',Id,this.selectedRate,this.selectedAmount,row.Qty,this.UserId,row.Unit,VehicleTypeId).subscribe(
      (response)=>{
        this.toastr.success('Rate updated successfully','Success');
        this.UpdatedRateAmountList();
        this.onRefreshParent.emit('true');
      },
      (error)=>{
        this.toastr.error('Error while updating Rate','Error');
      }
    )
  }

  getChangedValue(event){
    console.log('event',event);
    if(event.type === 'Unit' ){
      if(event.event){
        this.CalculateChargesByUnit(event.row.IndentId,event.row.TransporterId,event.event.value,event.row.Id);
      }
    }else{
      this.selectedRate=0;
      if(event.event){
        this.selectedRate=Number(event.event)
      }
    }
  }

  CalFooterValue() {
    var TotalQty = 0;
    var TotalRate = 0;
    var TotalAmount = 0;

    this.tableDetails.data.forEach((element) => {
      TotalQty += parseFloat(element.Qty);
      TotalRate += parseFloat(element.Rate);
      TotalAmount += parseFloat(element.Amount);
    });

    setTimeout(() => {
      // this.tableDetails.footerData[0].Qty = parseFloat(TotalQty.toString()).toFixed(2);
      // this.tableDetails.footerData[0].Rate = parseFloat(TotalRate.toString()).toFixed(2);
      this.tableDetails.footerData[0].Amount = parseFloat(TotalAmount.toString()).toFixed(2);
    }, 500);
  }

  UpdatedRateAmountList(){
    const Payload = {
      IndentId:this.OrderId,
      TransporterId:this.NetworkId,
      isBidding: this.isBidding,
      VehicleTypeId:this.VehicleTypeId
    };
    this._appService.Post('OrdersByVehicle', 'GetShipNowChargeBreakupListByVehicle', Payload).subscribe(
      (response) => {
        if(response.length){
          this.tableDetails.data = response || [];
          this.tableDetails.data = response.map((item, index) => {
          return {
            ...item,
            SerialNumber: index + 1
          };
        });
        }
        this.CalFooterValue();
      },
      (err) => {
        this.toastr.error("Error occurred while fetching data !", "error");
        Helpers.setLoading(false)
      }
    );
  }

  CalculateChargesByUnit(OrderId,NetworkId,ChargesPer,selectedId){
    let obj:any={};
    obj.OrderId=OrderId;
    obj.NetworkId=NetworkId;
    obj.ChargesPer=ChargesPer;
    obj.UnitRate=0;
    this._appService.Post('OrdersByVehicle','CalculateChargesByUnit',obj).subscribe(
      (response)=>{
        if(response && response.length>0){
          console.log(response[0].Qty);
          const newQTY = response[0].Qty;
          console.log('newQTY',newQTY);
          const updatedRow = this.tableDetails.data.find(x => x.Id === selectedId);
          if (updatedRow) {
            updatedRow.Qty = newQTY;
            updatedRow.Amount = newQTY * updatedRow.Rate;
            updatedRow.Unit = ChargesPer;
          }
          this.CalFooterValue();
        }
      },
      (error)=>{
        this.toastr.error('Error while calculating qty','Error');
      }
    );
  }

  Save(){
    console.log('this.totalBidAmount',this.totalBidAmount, typeof this.totalBidAmount);
    const TotalAmount = this.tableDetails.data.reduce(
      (sum: number, item: any) => sum + (Number(item.Amount) || 0),
      0
    );
    if(this.IsContracted === false || this.IsContracted === 'false'){
      if(TotalAmount > this.totalBidAmount){
        this.toastr.warning('Amount should be less than the maximum bid amount','Warning');
        return;
      }
    }

    let obj: any = {};
    obj.Amount = TotalAmount || 0;
    obj.AvailableDate = this.AvailableDate;
    obj.VehicleTypeId = this.VehicleTypeId;
    obj.TransportersBidsId = this.TransportersBidsId;
    obj.TransportersBidsDetailsId = this.TransportersBidsDetailsId;
    obj.CreatedBy = this.UserId;
    console.log("SaveBid:", obj);

      this._appService.Post("OrdersByVehicle", "UpdateBidRequest", obj).subscribe(
        (response) => {
          if (response[0].isDone == 'OK') {
            this.toastr.success("Bid details save suceessfully!", 'Save');
            this.onRefreshParent.emit('true');
            this.Cancel()
          }
        },
        (error) => {
          console.error("Error while saving data");
        }
      );

  }
}
